import React, { useState, useRef } from 'react';
import { Button, Grow, Paper, Popper, MenuItem, MenuList } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import ChevronDownIcon from 'public/icons/chevron-down.svg';
import ChevronUpIcon from 'public/icons/chevron-up.svg';

const useStyles = makeStyles({
  root: {
    boxShadow: 'none',
    minWidth: 'fit-content',
  },

  paper: {
    borderRadius: 10,
    boxShadow: '0 0 30px 0 rgba(0, 0, 0, 0.1)',
  },

  menuList: {
    padding: '12px 10px',
  },

  menuListItem: {
    padding: '5px 5px',
    margin: '3px 0',
    fontFamily: 'Avenir Heavy',
    fontSize: 14,
    color: '#323643',

    '&:hover': {
      backgroundColor: '#e8fefc',
      borderRadius: 5,
      color: '#323643',
    },
  },
});

const marginRight = { marginRight: 10, color: '#323643' };
const zIndex = { zIndex: 11 };
const iconStyle = {
  filter:
    'invert(50%) sepia(76%) saturate(6994%) hue-rotate(250deg) brightness(79%) contrast(125%)',
};
const btnStyle = {
  textTransform: 'initial',
  fontWeight: 400,
  fontFamily: 'Avenir Roman',
  padding: 0,
  fontSize: 16,
  letterSpacing: '-0.09px',
};

const SimpleSortDropdown = ({
  menuItems = [],
  selectedItem,
  setSelectedItem,
  handleClick,
  textAlign,
  maxHeight,
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef();

  const handleCloseMenu = event => {
    if (anchorRef?.current && anchorRef?.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleClose = () => setOpen(false);

  const handleToggle = () => (open ? handleClose() : setOpen(true));

  const handleSelect = item => setSelectedItem(item.name);

  return (
    <div className={classes.root} style={{ textAlign: textAlign || '' }}>
      <Button
        ref={anchorRef}
        onClick={handleToggle}
        disableRipple
        className="hover-icon"
        style={btnStyle}
        endIcon={
          open ? (
            <ChevronUpIcon width={12} height={12} style={iconStyle} />
          ) : (
            <ChevronDownIcon width={12} height={12} />
          )
        }
      >
        {selectedItem}
      </Button>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-end"
        transition
        style={zIndex}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper
              className={classes.paper}
              style={{
                minWidth: 160,
                ...(maxHeight ? { maxHeight, overflowY: 'auto' } : {}),
              }}
            >
              <ClickAwayListener onClickAway={handleCloseMenu}>
                <MenuList className={classes.menuList}>
                  {menuItems.map((item, index) => (
                    <div key={index}>
                      <MenuItem
                        onClick={() => {
                          if (handleClick) handleClick(item.name);
                          handleSelect(item);
                          handleClose();
                        }}
                        className={classes.menuListItem}
                      >
                        {item.icon && <span style={marginRight}>{item.icon}</span>}

                        {item.name || item.title}
                      </MenuItem>
                    </div>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  );
};

export default SimpleSortDropdown;
